import { isAdmin } from '@debbie/common/dist/permissions';
import { h } from '../';
export const selectTenant = (state) => {
    const me = state.me;
    if (!h.isLoaded(me) || state.selectedOwners.length === 0) {
        return null;
    }
    return (me.data.tenants.find((tenant) => tenant.id === state.selectedOwners[0]) || null);
};
export const selectTenantById = (state, id) => {
    const me = state.me;
    if (!h.isLoaded(me) || state.selectedOwners.length === 0) {
        return null;
    }
    return (me.data.tenants.find((tenant) => tenant.id === id) || null);
};
export const selectMe = (state) => {
    const me = state.me;
    if (!h.hasData(me)) {
        return null;
    }
    return me.data;
};
export const selectIsAdmin = (state) => {
    const me = state.me;
    if (!h.hasData(me)) {
        return false;
    }
    return me.data && isAdmin(me.data.role);
};
export const selectRole = (state) => {
    const me = state.me;
    if (!h.hasData(me)) {
        return null;
    }
    const role = me.data.tenants.find((tenant) => tenant.id === state.selectedOwners[0]);
    return (role === null || role === void 0 ? void 0 : role.role) || null;
};
//# sourceMappingURL=selectors.js.map